import { createAction } from 'src/lib/createAction';

export const layoutActions = {
  hideMobileMenu: createAction('layout/hideMobileMenu')(),
  setActivePanelCategory: createAction('layout/setActivePanelCategory')<string | null>(),
  showMobileCategories: createAction('layout/showMobileCategories')(),
  showMobileMenu: createAction('layout/showMobileMenu')(),
};
